import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'number',
})
export class NumberPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const decimals = args[0];

    if (!decimals) {
      value = Math.round(value);
    }

    // Add commas to the  number
    const total = value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    // Join and trim trailing zeros
    return total.replace(/\.00$/, '');
  }
}
